import { useSelector } from 'react-redux';
import React, { } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';

const ProProgressSpinner = () => {
    const spinner = useSelector(state => state.spinner);
    return (
        <div>
            {
                spinner.show &&
                <div className="ui-loader">
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" />
                </div>
            }
        </div>
    )
}

export default ProProgressSpinner;